const userReducer = (user = {}, action) => {
    switch (action.type) {
        case "ADD_USER":
            return action.user;
        case "LOGOUT_USER":
            return {};
        case "UPDATE_COMPANY":
            if (user.allowed_companies) {
                return {
                    ...user,
                    allowed_companies: user.allowed_companies.map(company => 
                        company.id === action.companyId 
                            ? { ...company, ...action.companyData }
                            : company
                    )
                };
            }
            return user;
        default:
            return user;
    }
};

export default userReducer;
